const SW_ACTIVATION_TIMEOUT = 5000;

/**
 * Activates a waiting service worker and waits for it to take control.
 * Returns true if a waiting SW was found and activated, false otherwise.
 */
export async function activateWaitingServiceWorker(): Promise<boolean> {
    if (!('serviceWorker' in navigator)) return false;

    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration?.waiting) return false;

    registration.waiting.postMessage({ type: 'SKIP_WAITING' });

    await Promise.race([
        new Promise<void>((resolve) => {
            navigator.serviceWorker.addEventListener('controllerchange', () => resolve(), { once: true });
        }),
        new Promise<void>((resolve) => setTimeout(resolve, SW_ACTIVATION_TIMEOUT)),
    ]);

    return true;
}
